import React, { useEffect, useState,useRef } from 'react';
import { Formik } from 'formik';
import './fabric-quality-list.scss';
import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core/styles';import GodownService from '../../services/godown.service';
import { Container, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import FullYarnCountService from '../../services/full-yarn-count.service';
import FabricTypeService from '../../services/fabric-type.service';
import HSCodeService from '../../services/hsCode.service';
import FabricThreadCountService from '../../services/fabric-thread-count.service';
import FabricYarnDescriptionService from '../../services/fabric-yarn-description.service';
import FabricCategoryService from '../../services/fabric-category.service';
import FabricQualityService from '../../services/fabric-quality.service';
import { TextBoxComponent ,NumericTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { ClickEventArgs } from '@syncfusion/ej2-react-navigations';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import FullYarnCountList from '../full-yarn-count/full-yarn-count-list';
import SetupAdd from '../setup/setup-add';
import moment from 'moment';
import SecurityService from "../security/security.service";
import CheckDuplicate from '../check-duplicate/check-duplicate';
var allFabricQuality;

export default function YarnPurchaseContractEdit(props) {
  console.log(props)
  const [fabricType, setFabricType] = useState([]);
  const [loadingFabricType, setFabricTypeLoading] = useState(false);
  
  const [fullYarnCounts, setFullYarnCounts] = useState([]);
  const [loadingFullYarnCounts, setFullYarnCountsLoading] = useState(false);
  const [fabricYarnDescriptionValue ,setFabricYarnDescriptionValue] = useState(props.FabricYarnDesc)
  const [WarpFullYarnCount, setWarpFullYarnCount ] = useState();
  const [loadingWarpFullYarnCounts, setWarpFullYarnCountsLoading] = useState(false);
  const [WeftFullYarnCount, setWeftFullYarnCount ] = useState();
  const [loadingWeftFullYarnCounts, setWeftFullYarnCountsLoading] = useState(false);

  const [fabricThreadCount, setFabricThreadCount] = useState([]);
  const [loadingFabricThreadCount, setFabricThreadCountLoading] = useState(false);

  const [fabricYarnDescription, setFabricYarnDescription] = useState([]);
  const [loadingFabricYarnDescription, setFabricYarnDescriptionLoading] = useState(false);

  const [fabricCategory, setFabricCategory] = useState([]);
  const [loadingFabricCategory, setFabricCategoryLoading] = useState(false);

  const [pickYarnThread, setPickYarnThread] = useState(props.PickYarnThread);
  const [addNewClicked, setAddNewClicked] = useState(false);
  const [hSCode, setHSCode] = useState([]);
  const [loadingHSCode, setHSCodeLoading] = useState(false);
  
  
  const [showAddNewDialog, setShowAddNewDialog] = useState(false);
  const [newValue, setNewValue] =useState('');
  const [WarpFullYarnCountID, setWarpFullYarnCountID]=useState(props.WarpFullYarnCountID);
  const [WeftFullYarnCountID, setWeftFullYarnCountID]=useState(props.WeftFullYarnCountID);
  const [warpFullYarnCountValue, setWarpFullYarnCountValue]=useState(props.WarpFullYarnCount);
  // const [weftFullYarnCountValue, setWeftFullYarnCountValue]=useState();
  // const [ends, setEnds]=useState();
  // const [picks, setPicks]=useState();
  // const [width, setWidth]=useState();
  // const [fabricTypeID, setFabricTypeID] = useState();
  const [fabricTypeValue, setFabricTypeValue] = useState(props.FabricTypeDesc);
  // const [fabricThreadCountID, setFabricThreadCountID] = useState([]);
  const [fabricThreadCountValue, setFabricThreadCountValue] = useState(props.FabricThreadCountDesc);
  const [fabricQualityValue, setFabricQualityValue] = useState(props.FabricQualityDesc);
  const [fabricYarnValue, setFabricYarnValue] = useState([]);
  // const [fabricYarnDescriptionID, setFabricYarnDescriptionID] = useState([]);
  // const [fabricCategoryID, setFabricCategoryID] = useState([]);
  const [fabricCategoryValue, setFabricCategoryValue] = useState(props.FabricCategoryDesc);
  // const [hSCodeID, setHSCodeID] = useState([]);
  const [hsCodeNoValue, setHsCodeNoValue] = useState(props.HSCodeNo);
  // const [dialogType, setDialogType] = useState('');
  // const fabricTypes = useRef()

  const [weftFullYarnCountValue, setWeftFullYarnCountValue]=useState(props.WeftFullYarnCount);

  const [fabricTypeID, setFabricTypeID] = useState(props.FabricTypeID);
  const [fabricThreadCountID, setFabricThreadCountID] = useState(props.FabricThreadCountID);
  const [fabricYarnDescriptionID, setFabricYarnDescriptionID] = useState(props.FabricYarnDescID);
  const [fabricCategoryID, setFabricCategoryID] = useState(props.FabricCategoryID);
  const [hSCodeID, setHSCodeID] = useState(props.HSCodeID);
  const [dialogType, setDialogType] = useState('');
const fabricTypes= useRef()
const [ends, setEnds]=useState(props.Ends);
const [picks, setPicks]=useState(props.Picks);
const [width, setWidth]=useState(props.Width);
const [checkDuplicate, setCheckDuplicate] = useState(false);
const [checkDuplicateValue, setCheckDuplicateValue] = useState('');
useEffect(() => {
setTimeout(() => {
  

  if(WarpFullYarnCountID != undefined && WeftFullYarnCountID != 0 && WeftFullYarnCountID != undefined && ends != undefined && picks != undefined &&  width != undefined && pickYarnThread != undefined  && checkDuplicate == true){
    console.log(props.dataList)
    console.log({
      warpFullYarnCount:warpFullYarnCountValue,
      WeftFullYarnCount:weftFullYarnCountValue,
      Ends:ends,
      Picks:picks,
      Width:width,
      PickYarnThread:pickYarnThread})
      var check = false;
   if(props.isAdd ==  true){

   
       check = CheckDuplicate.withCombination(props.dataList,['WarpFullYarnCount','WeftFullYarnCount','Ends','Picks','Width','PickYarnThread'],{
      
      WarpFullYarnCount:warpFullYarnCountValue,
      WeftFullYarnCount:weftFullYarnCountValue,
      Ends:ends,
      Picks:picks,
      Width:width,
      PickYarnThread:pickYarnThread

    })
  }else{
    let array = props.dataList.filter(obj => obj.FabricQualityID !== props.FabricQualityID)

     check = CheckDuplicate.withCombination(array,['WarpFullYarnCount','WeftFullYarnCount','Ends','Picks','Width','PickYarnThread'],{
    
    WarpFullYarnCount:warpFullYarnCountValue,
    WeftFullYarnCount:weftFullYarnCountValue,
    Ends:ends,
    Picks:picks,
    Width:width,
    PickYarnThread:pickYarnThread

  })

  }
    console.log(check)
    
    if(!check){
      document.querySelector('#fabricQualityGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='visible';
      setCheckDuplicateValue('')
    }else{
      document.querySelector('#fabricQualityGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='hidden';
      setCheckDuplicateValue('Duplicate Value Detected!')
  }
 }
}, 500);
}, [WarpFullYarnCountID,WeftFullYarnCountID,ends,picks,width,pickYarnThread ]);
  const useStyles = makeStyles((theme) => ({
    fromWrapper: {
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(8),
    },
  }));

  useEffect(() => {
    setTimeout(() => {
      setCheckDuplicate(true)
      if(props.isAdd ==  false){
        document.querySelector('#fabricQualityGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='visible';

      }
    }, 500);
    getFabricType();
    getWarpFullYarnCounts();
    getWeftFullYarnCounts();
    getFabricThreadCount();
    getFabricYarnDescription();
    getFabricCategory();
    getHSCode();
  }, []);

  const getFabricType = async () => {
    setFabricTypeLoading(true);
    FabricTypeService.getFabricTypeForList()
      .then((response) => {
        setFabricType(response.data.recordset);
        setFabricTypeLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setFabricTypeLoading(false);
      });
  };

  const getWarpFullYarnCounts = async () => {
    setWarpFullYarnCountsLoading(true);
    FullYarnCountService.getYarnContractFullYarnCount()
      .then((response) => {
        setWarpFullYarnCount(response.data.recordset);
        setWarpFullYarnCountsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setWarpFullYarnCountsLoading(false);
      });
  };

  const getWeftFullYarnCounts = async () => {
    setWeftFullYarnCountsLoading(true);
    FullYarnCountService.getYarnContractFullYarnCount()
      .then((response) => {
        setWeftFullYarnCount(response.data.recordset);
        setWeftFullYarnCountsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setWeftFullYarnCountsLoading(false);
      });
  };

  const getFabricThreadCount = async () => {
    setFabricThreadCountLoading(true);
    FabricThreadCountService.getFabricThreadCountForList()
      .then((response) => {
        setFabricThreadCount(response.data.recordset);
        setFabricThreadCountLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setFabricThreadCountLoading(false);
      });
  };

  const getFabricYarnDescription = async () => {
    setFabricYarnDescriptionLoading(true);
    FabricYarnDescriptionService.getFabricYarnDescriptionForList()
      .then((response) => {
        setFabricYarnDescription(response.data.recordset);
        setFabricYarnDescriptionLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setFabricYarnDescriptionLoading(false);
      });
  };

  const getFabricCategory = async () => {
    setFabricCategoryLoading(true);
    FabricCategoryService.getFabricCategoryForList()
      .then((response) => {
        setFabricCategory(response.data.recordset);
        setFabricCategoryLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setFabricCategoryLoading(false);
      });
  };


  const getHSCode = async () => {
    setHSCodeLoading(true);
    HSCodeService.getYarnContractImportLC()
      .then((response) => {
        setHSCode(response.data.recordset);
        setHSCodeLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setHSCodeLoading(false);
      });
  };


  const INITIAL_FORM_STATE = {
    FabricQualityID: props.FabricQualityID,
    FabricTypeID: '',
    WarpFullYarnCountID: '',
    WeftFullYarnCountID: '',
    Ends: '',
    Picks: '',
    Width: '',
    PickYarnThread: '',
    FabricThreadCountID: '',
    FabricQualityDesc: '',
    FabricYarnDescID: '',
    FabricCategoryID: '',
    HSCodeID: '',
  };

   
  const fabricTypeChange = (e) => {
    if(e?.e?.srcElement?.id)  {
      console.log('FabricTypeID change: ', e?.itemData?.id);
      // const inputId = e?.e?.srcElement.id;
      // if(inputId === 'FullYarnCount'){
        setFabricTypeID(e?.itemData?.id);
      // }
    }
  };
  
  const WarpFullYarnCountChange = (e) => {
    if(e?.e?.srcElement?.id)  {
      setWarpFullYarnCountValue(e?.itemData?.value)
      console.log('yarn count change: ', e?.itemData?.id);
      // const inputId = e?.e?.srcElement.id;
      // if(inputId === 'FullYarnCount'){
        setWarpFullYarnCountID(e?.itemData?.id);
      // }
    }
  };

  const WeftFullYarnCountChange = (e) => {
    if(e?.e?.srcElement?.id)  {
      setWeftFullYarnCountValue(e?.itemData?.value)
      console.log('yarn count change: ', e?.itemData?.id);
      // const inputId = e?.e?.srcElement.id;
      // if(inputId === 'FullYarnCount'){
        setWeftFullYarnCountID(e?.itemData?.id);
      // }
    }
  };

  const fabricThreadCountChange = (e) => {
    if(e?.e?.srcElement?.id)  {
      console.log('FabricThreadCountID change: ', e?.itemData?.id);
      // const inputId = e?.e?.srcElement.id;
      // if(inputId === 'FullYarnCount'){
        setFabricThreadCountID(e?.itemData?.id);
      // }
    }
  };
  
  const fabricYarnDescriptionChange = (e) => {
    if(e?.e?.srcElement?.id)  {
      console.log('FabricYarnDescID change: ', e?.itemData?.id);
      // const inputId = e?.e?.srcElement.id;
      // if(inputId === 'FullYarnCount'){
        setFabricYarnDescriptionID(e?.itemData?.id);
      // }
    }
  };

  const fabricCategoryChange = (e) => {
    if(e?.e?.srcElement?.id)  {
      console.log('FabricCategoryID change: ', e?.itemData?.id);
      // const inputId = e?.e?.srcElement.id;
      // if(inputId === 'FullYarnCount'){
        setFabricCategoryID(e?.itemData?.id);
      // }
    }
  };

  const hSCodeChange = (e) => {
    if(e?.e?.srcElement?.id)  {
      console.log('HSCodeID change: ', e?.itemData?.id);
      // const inputId = e?.e?.srcElement.id;
      // if(inputId === 'FullYarnCount'){
        setHSCodeID(e?.itemData?.id);
      // }
    }
  };
  // const fields: object = { text: 'value', value: 'id' };

  const ddlFields: object = { value: 'value' };
  const classes = useStyles();

  const minDate: Date = new Date(moment().startOf('day'));
  
  const WarpFullYarnCountSelect = (e) =>{
    console.log('WarpFullYarnCount e: ', e.itemData.id);
    setWarpFullYarnCount(e.itemData.id);
  }

  const WeftFullYarnCountSelect = (e) =>{
    console.log('WeftFullYarnCount e: ', e.itemData.id);
    setWeftFullYarnCount(e.itemData.id);
  }

  const onAddNewClick = (type) => {
    if(type !== ''){
      setShowAddNewDialog(false);
      setDialogType(type);
      setTimeout(() => {
        setShowAddNewDialog(true);
      },100)
    }
  };

  const header = () => {
    if(showAddNewDialog) {
      return <div>Add New {dialogType.match(/[A-Z][a-z]+/g).join(" ")} </div>;
    }
    else {
      return (<></>);
    }
  };

  const AddNewSecurity = (addNewType) => {
    var res =""
      switch(SecurityService.canUserAccess(`${addNewType}List`)){
      case true:
        //('true')
       return res = 'ADD NEW';
      default:
        break;
    } 
   return res
  }
  let hsCodeRef = useRef(null)
  let fabricYarnDescriptionRef = useRef(null) 
  let warpFullYarnCountRef = useRef(null)
  const onClose = () => {
    setAddNewClicked(false)

    setShowAddNewDialog(false);
    switch(dialogType){
      case 'FabricType':
        getFabricType();
        break;
      case 'WarpFullYarnCount':
        getWarpFullYarnCounts();
        getWeftFullYarnCounts();
        break;
      case 'WeftFullYarnCount':
        getWarpFullYarnCounts();
        getWeftFullYarnCounts();
        break;
      case 'FabricThreadCount':
          getFabricThreadCount();
          break;
      case 'FabricYarnDescription':
        getFabricYarnDescription();
        break;
      case 'FabricCategory':
        getFabricCategory();
        break;
      case 'HSCode':
        getHSCode();
        break;
      default:
        break;
    } 
  }
  let fabricThreadCountRef = useRef(null)
  const footerTemplate = () => {
    if(showAddNewDialog){
      return (<div>
        <button id="btnSave" className="e-control e-btn e-primary" data-ripple="true" onClick={onClose}>Close</button>
      </div>);
    }
    else{
      return (<></>);
    }
  }
  
  const contentTemplate = () => {
    if(showAddNewDialog){
      console.log('dialog template');
      if (dialogType === 'WeftFullYarnCount'){
        return(
          <FullYarnCountList isDialog={true}/>
        );
      } else if (dialogType === 'WarpFullYarnCount'){
        return(
          <FullYarnCountList isDialog={true}/>
        )
      } else {
        return (
          <div>
            <SetupAdd type={dialogType} isDialog={true}
            /> 
            {/* <SetupAdd onChange={value => setWord(value)}*/}
          </div>
        );  
      }
    }
    else {
      return (
        <></>
      );
    }
  };
  let fabricCategoryRef = useRef(null)
  let weftFullYarnCountRef = useRef(null)
  // const AddNewSecurity = (addNewType) => {
  //   var res =""
  //     switch(SecurityService.canUserAccess(`${addNewType}List`)){
  //     case true:
  //       //('true')
  //      return res = 'ADD NEW';
  //     default:
  //       break;
  //   } 
  //  return res
  // }
  

  return (
    <div className='full-yarn-count-container'  onKeyDown={(e)=>{
      console.log(e)
      if(e.keyCode == 13){
        e.stopPropagation()

      }
    }}>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className='heading'>
            <h3 style={{ textAlign:'center', width: '100%' }}>Fabric Quality - Edit</h3>
          </div>
          
        </Grid>
        <div className='App' id='dialog-target'>
            <DialogComponent
              width='800px'
              visible={showAddNewDialog}
              close={showAddNewDialog}
              content={contentTemplate}
              isModal={true}
              header={header}
              footerTemplate = {footerTemplate}
            />
          </div>
        <Grid item xs={12}>
          <Container>
            <div className={classes.fromWrapper}>
              <Formik
                initialValues={{
                  ...INITIAL_FORM_STATE,
                }}
                // validationSchema={FORM_VALIDATION}
                onSubmit={async (values) => {
                  console.log('form values: ', values);
                  return new Promise((res) => {
                    FabricQualityService.update(values).then(
                      (response) => {
                        console.log('response: ', response);
                      }
                    );
                    setTimeout(res, 2500);
                  });
                }}
              >
                {({ values, errors, isSubmitting }) => (
                  <div>
                    {/* <pre> {JSON.stringify({ values, errors }, null, 3)} </pre> */}
                    <Grid container spacing={2}>

                      
                      <Grid item xs={3}>
                        {loadingFabricType ? (
                          <div>... Loading FabricType </div>
                        ) : (
                          <div>
                            <AutoCompleteComponent
                            created={(e)=>{
                              console.log(e , fabricTypes)
                              fabricTypes.current.element.focus()                           }} 
                              id="FabricType" dataSource={fabricType}  
                              placeholder="Select Fabric Type" fields={ddlFields}
                              floatLabelType='Auto' highlight={true}
                              select={fabricTypeChange}
                              change={fabricTypeChange} 
                              // value={}
                              ref={fabricTypes}
                              value={fabricTypeValue}
                              blur={()=>{
                                if (fabricTypeID === undefined || fabricTypeID == 0 || fabricTypes.current.value == null || fabricTypes.current.value == '')  {
                                  
                                  if(fabricTypeValue !=''){
                                 let resstr = fabricType.some(e=>e.value ==  fabricTypeValue);
                                 console.log(resstr)
                                 if(resstr === false){
                                  //  setProductTypeError(`${ActivtyValue} Value Not Find ` )
                                   document.getElementById("FabricType").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                   setTimeout(() => {
                                    //  setProductItemTypeError('')
                                     document.getElementById("FabricType").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'
        
                                   }, 1000);
                                   if(addNewClicked == false){
                                    fabricTypes.current.element.focus()
                                   }
                                       }
                                     }
                                     }
                             }}
                            />
                            <TextBoxComponent
                            className='e-input'
                            type='hidden'
                            placeholder='Fabric Type Id'
                            name='FabricTypeID'
                            floatLabelType='Auto'
                            value={fabricTypeID}
                          />
                            <span className='add-new' onClick={()=>onAddNewClick('FabricType')}>
                            {AddNewSecurity('FabricType')}
                            </span>
                          </div>
                        )}
                      </Grid>

                      
                      <Grid item xs={3}>
                        {loadingWarpFullYarnCounts ? (
                          <div>... Loading Yarn Counts </div>
                        ) : (
                          <div>
                            <AutoCompleteComponent 
                              id="WarpFullYarnCount" dataSource={WarpFullYarnCount}  
                              placeholder="Select Warp Yarn Count" fields={ddlFields}
                              floatLabelType='Auto' highlight={true}
                              select={WarpFullYarnCountChange}
                              change={WarpFullYarnCountChange} 
                              value={warpFullYarnCountValue}
                              ref={warpFullYarnCountRef}
                              blur={()=>{
                                if (WarpFullYarnCountID === undefined || WarpFullYarnCountID == 0 || warpFullYarnCountRef.current.value == null || warpFullYarnCountRef.current.value == '')  {
                                  if(addNewClicked == false){
                                  warpFullYarnCountRef.current.element.focus()
                                  }
                                  if(warpFullYarnCountValue !=''){
                                 let resstr = WarpFullYarnCount.some(e=>e.value ==  warpFullYarnCountValue);
                                 console.log(resstr)
                                 if(resstr === false){
                                  //  setProductTypeError(`${ActivtyValue} Value Not Find ` )
                                   document.getElementById("WarpFullYarnCount").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                   setTimeout(() => {
                                    //  setProductItemTypeError('')
                                     document.getElementById("WarpFullYarnCount").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'
        
                                   }, 1000);
                                       }
                                     }
                                     }
                             }}
                            />
                            <TextBoxComponent
                            className='e-input'
                            type='hidden'
                            placeholder='Full Yarn Count Id'
                            name='WarpFullYarnCountID'
                            floatLabelType='Auto'
                            value={WarpFullYarnCountID}
                          />
                            <span className='add-new' onClick={()=>onAddNewClick('WarpFullYarnCount')}>
                                {AddNewSecurity('FullYarnCount')}
                            </span>
                          </div>
                        )}
                      </Grid>


                      <Grid item xs={3}>
                        {loadingWeftFullYarnCounts ? (
                          <div>... Loading Yarn Counts </div>
                        ) : (
                          <div>
                            <AutoCompleteComponent 
                              id="WeftFullYarnCount" dataSource={WeftFullYarnCount}  
                              placeholder="Select Weft Yarn Count" fields={ddlFields}
                              floatLabelType='Auto' highlight={true}
                              select={WeftFullYarnCountChange}
                              change={WeftFullYarnCountChange}
                              value={weftFullYarnCountValue} 
                              ref={weftFullYarnCountRef}
                              blur={()=>{
                                if (WeftFullYarnCountID === undefined || WeftFullYarnCountID == 0 || weftFullYarnCountRef.current.value == null || weftFullYarnCountRef.current.value == '')  {
                                  if(addNewClicked == false){
                                  weftFullYarnCountRef.current.element.focus()
                                  }
                                  if(weftFullYarnCountValue !=''){
                                 let resstr = WeftFullYarnCount.some(e=>e.value ==  weftFullYarnCountValue);
                                 console.log(resstr)
                                 if(resstr === false){
                                  //  setProductTypeError(`${ActivtyValue} Value Not Find ` )
                                   document.getElementById("WeftFullYarnCount").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                   setTimeout(() => {
                                    //  setProductItemTypeError('')
                                     document.getElementById("WeftFullYarnCount").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'
        
                                   }, 1000);
                                       }
                                     }
                                     }
                             }}
                            />
                            <TextBoxComponent
                            className='e-input'
                            type='hidden'
                            placeholder='Full Yarn Count Id'
                            name='WeftFullYarnCountID'
                            floatLabelType='Auto'
                            value={WeftFullYarnCountID}
                          />
                            <span className='add-new' onClick={()=>onAddNewClick('WeftFullYarnCount')}>
                            {AddNewSecurity('FullYarnCount')}
                            </span>
                          </div>
                        )}
                      </Grid>

                      <Grid item xs={3}>
                        <TextBoxComponent
                          className='e-input'
                          type='number'
                          placeholder='Ends'
                          name='Ends'
                          floatLabelType='Auto'
                          value={ends}
                          onChange={(e)=>setEnds(e.value)}
                          
                        />
                      </Grid>
                      
                      <Grid item xs={3}>
                        <TextBoxComponent
                          className='e-input'
                          type='number'
                          placeholder='Picks'
                          name='Picks'
                          floatLabelType='Auto'
                          value={picks}
                          onChange={(e)=>setPicks(e.value)}
                        />
                      </Grid>

                      <Grid item xs={3}>
                        <TextBoxComponent
                          className='e-input'
                          type='number'
                          placeholder='Width'
                          name='Width'
                          floatLabelType='Auto'
                          value={width}
                          onChange={(e)=>setWidth(e.value)}
                        />
                      </Grid>

                      <Grid item xs={3}>
                        <TextBoxComponent
                          className='e-input'
                          type='number'
                          placeholder='Single / Double Pick'
                          name='PickYarnThread'
                          floatLabelType='Auto'
                          value={pickYarnThread}
                          onChange={(e)=>setPickYarnThread(e.value)}
                          
                        />
                      </Grid>
                      <Grid item xs={3}>
                        {loadingFabricThreadCount ? (
                          <div>... Loading FabricThreadCount </div>
                        ) : (
                          <div>
                            <AutoCompleteComponent 
                              id="FabricThreadCount" dataSource={fabricThreadCount}  
                              placeholder="Select Fabric Thread Count" fields={ddlFields}
                              floatLabelType='Auto' highlight={true}
                              select={fabricThreadCountChange}
                              change={fabricThreadCountChange} 
                              value={fabricThreadCountValue}
                              ref={fabricThreadCountRef}
                              blur={()=>{
                                if (fabricThreadCountID === undefined || fabricThreadCountID == 0 || fabricThreadCountRef.current.value == null || fabricThreadCountRef.current.value == '')  {
                                  if(addNewClicked == false){
                                  fabricThreadCountRef.current.element.focus()
                                  }
                                  if(fabricThreadCountValue !=''){
                                 let resstr = fabricThreadCount.some(e=>e.value ==  fabricThreadCountValue);
                                 console.log(resstr)
                                 if(resstr === false){
                                  //  setProductTypeError(`${ActivtyValue} Value Not Find ` )
                                   document.getElementById("FabricThreadCount").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                   setTimeout(() => {
                                    //  setProductItemTypeError('')
                                     document.getElementById("FabricThreadCount").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'
        
                                   }, 1000);
                                       }
                                     }
                                     }
                             }}
                            />
                            <TextBoxComponent
                            className='e-input'
                            type='hidden'
                            placeholder='FabricThreadCount Id'
                            name='FabricThreadCountID'
                            floatLabelType='Auto'
                            value={fabricThreadCountID}
                          />
                            <span className='add-new' onClick={()=>onAddNewClick('FabricThreadCount')}>
                            {AddNewSecurity('FabricThreadCount')}
                            </span>
                          </div>
                        )}
                      </Grid>

                      <Grid item xs={6}>
                        <TextBoxComponent
                          className='e-input'
                          type='text'
                          placeholder='Fabric Quality Description'
                          name='FabricQualityDesc'
                          floatLabelType='Auto'
                          value={fabricQualityValue}
                        />
                      </Grid>

                      <Grid item xs={3}>
                        {loadingFabricYarnDescription ? (
                          <div>... Loading FabricYarnDescription </div>
                        ) : (
                          <div>
                            <AutoCompleteComponent 
                              id="FabricYarnDesc" dataSource={fabricYarnDescription}  
                              placeholder="Select Fabric Yarn Description" fields={ddlFields}
                              floatLabelType='Auto' highlight={true}
                              select={fabricYarnDescriptionChange}
                              change={fabricYarnDescriptionChange} 
                              value={fabricYarnDescriptionValue}
                              ref={fabricYarnDescriptionRef}
                              blur={()=>{
                                if (fabricYarnDescriptionID === undefined || fabricYarnDescriptionID == 0 || fabricYarnDescriptionRef.current.value == null || fabricYarnDescriptionRef.current.value == '')  {
                                  if(addNewClicked == false){
                                  fabricYarnDescriptionRef.current.element.focus()
                                  }
                                  if(fabricYarnDescriptionValue !=''){
                                 let resstr = fabricYarnDescription.some(e=>e.value ==  fabricYarnDescriptionValue);
                                 console.log(resstr)
                                 if(resstr === false){
                                  //  setProductTypeError(`${ActivtyValue} Value Not Find ` )
                                   document.getElementById("FabricYarnDesc").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                   setTimeout(() => {
                                    //  setProductItemTypeError('')
                                     document.getElementById("FabricYarnDesc").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'
        
                                   }, 1000);
                                       }
                                     }
                                     }
                             }}
                            />
                            <TextBoxComponent
                            className='e-input'
                            type='hidden'
                            placeholder='Fabric Yarn Description Id'
                            name='FabricYarnDescID'
                            floatLabelType='Auto'
                            value={fabricYarnDescriptionID}
                          />
                            <span className='add-new' onClick={()=>onAddNewClick('FabricYarnDescription')}>
                            {AddNewSecurity('FabricYarnDescription')}
                            </span>
                          </div>
                        )}
                      </Grid>


                      <Grid item xs={3}>
                        {loadingFabricCategory ? (
                          <div>... Loading FabricCategory </div>
                        ) : (
                          <div>
                            <AutoCompleteComponent 
                              id="FabricCategory" dataSource={fabricCategory}  
                              placeholder="Select Fabric Category" fields={ddlFields}
                              floatLabelType='Auto' highlight={true}
                              select={fabricCategoryChange}
                              change={fabricCategoryChange}
                              value={fabricCategoryValue}
                              ref={fabricCategoryRef}
                              blur={()=>{
                                if (fabricCategoryID === undefined || fabricCategoryID == 0 || fabricCategoryRef.current.value == null || fabricCategoryRef.current.value == '')  {
                                  if(addNewClicked == false){
                                  fabricCategoryRef.current.element.focus()
                                  }
                                  if(fabricCategoryValue !=''){
                                 let resstr = fabricCategory.some(e=>e.value ==  fabricCategoryValue);
                                 console.log(resstr)
                                 if(resstr === false){
                                  //  setProductTypeError(`${ActivtyValue} Value Not Find ` )
                                   document.getElementById("FabricCategory").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                   setTimeout(() => {
                                    //  setProductItemTypeError('')
                                     document.getElementById("FabricCategory").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'
        
                                   }, 1000);
                                       }
                                     }
                                     }
                             }}
                            />
                            <TextBoxComponent
                            className='e-input'
                            type='hidden'
                            placeholder='FabricCategory Id'
                            name='FabricCategoryID'
                            floatLabelType='Auto'
                            value={fabricCategoryID}
                          />
                            <span className='add-new' onClick={()=>onAddNewClick('FabricCategory')}>
                            {AddNewSecurity('FabricCategory')}
                            </span>
                          </div>
                        )}
                      </Grid>


                      <Grid item xs={3}>
                        {loadingHSCode ? (
                          <div>... Loading HSCode </div>
                        ) : (
                          <div>
                            <AutoCompleteComponent 
                              id="HSCode" dataSource={hSCode}  
                              placeholder="Select HSCode" fields={ddlFields}
                              floatLabelType='Auto' highlight={true}
                              select={hSCodeChange}
                              change={hSCodeChange} 
                              value={hsCodeNoValue}
                              ref={hsCodeRef}
                              blur={()=>{
                                if (hSCodeID === undefined || hSCodeID == 0 || hsCodeRef.current.value == null || hsCodeRef.current.value == '')  {
                                  if(addNewClicked == false){
                                  hsCodeRef.current.element.focus()
                                  }
                                  if(hsCodeNoValue !=''){
                                 let resstr = hSCode.some(e=>e.value ==  hsCodeNoValue);
                                 console.log(resstr)
                                 if(resstr === false){
                                  //  setProductTypeError(`${ActivtyValue} Value Not Find ` )
                                   document.getElementById("HSCode").parentElement.parentElement.firstChild.style.border ='3px solid red'
                                   setTimeout(() => {
                                    //  setProductItemTypeError('')
                                     document.getElementById("HSCode").parentElement.parentElement.firstChild.style.border ='1px solid #c8c8c8'
        
                                   }, 1000);
                                       }
                                     }
                                     }
                             }}
                            />
                            <TextBoxComponent
                            className='e-input'
                            type='hidden'
                            placeholder='HSCode Id'
                            name='HSCodeID'
                            floatLabelType='Auto'
                            value={hSCodeID}
                          />
                            <span className='add-new' onClick={()=>onAddNewClick('HSCode')}>
                            {AddNewSecurity('HSCode')}
                            </span>
                          </div>
                        )}
                      </Grid>
                             <Grid item xs={5}>
                             <h3 className="duplicate " style={checkDuplicateValue != '' ? {transform:'scale(1)'}:{}}>{checkDuplicateValue}</h3>

                             </Grid>

                      
                    </Grid>
                  </div>
                )}
              </Formik>
            </div>
          </Container>
        </Grid>
      </Grid>

    </div>
  );
}
